import { useWSSnackbar } from "@wingspanhq/fe-component-library";
import {
  InvoiceRow,
  SearchInvoiceRowsFilterParameter
} from "@wingspanhq/wingspan-api-sdk";
import { useCallback, useState } from "react";
import { queriesInvoiceRows } from "@query";
import { downloadCSV } from "../../Reports/utils/sheetjs/downloadCSV";
import { mapInvoiceToCsvTable } from "../utils/csv";

const CSV_PAGE_SIZE = 100;

export const useDownloadCsv = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<Error | null>(null);
  const { openSnackbar } = useWSSnackbar();

  const downloadCsv = useCallback(
    async ({ filter }: { filter?: SearchInvoiceRowsFilterParameter }) => {
      try {
        setIsLoading(true);
        setError(null);

        const invoices: InvoiceRow[] = [];
        let token: string | undefined = undefined;

        do {
          const page: Awaited<
            ReturnType<
              typeof queriesInvoiceRows.searchInvoiceRows.fetchQueryData
            >
          > = await queriesInvoiceRows.searchInvoiceRows.fetchQueryData({
            filter,
            page: { size: CSV_PAGE_SIZE, token }
          });
          invoices.push(...(page.data ?? []));
          token = page.pagination?.nextPageToken ?? undefined;
        } while (token);

        const csvData = invoices.map(invoice => mapInvoiceToCsvTable(invoice));

        downloadCSV(csvData, "Invoices");

        openSnackbar({
          type: "success",
          message: "CSV downloaded"
        });
      } catch (error) {
        setError(error as any);

        openSnackbar({
          type: "warning",
          message: "Failed to download CSV"
        });
      } finally {
        setIsLoading(false);
      }
    },
    [openSnackbar]
  );

  return {
    downloadCsv,
    isLoading,
    error
  };
};
